<template>
	<div>
		<upload-invoice
			:show="upload_dialogue"
			v-on:cancel="cancelUpload"
		></upload-invoice>
		<layout-12
			:table_name="'Invoice Status'"
			:auto_reload=true
			:id=pageid
			:term=term
			:buttonnames="['Send Selected Invoices To QB','Email Selected Invoices To Customers','Test ERP Next','Upload Invoice']"
			:buttonperms="['77','77','77','121']"
			:buttonnamefunction="['create','email','erp','upload']"
			v-on:button="button"
			style="width:100%; height:calc(100vh - 50px);">
		</layout-12>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.INVOICE_STATUS_PAGE,
			upload_dialogue:false,
		}
	},
	methods: {
		button(buttonname, selectedIndexs, column_data){
			if(buttonname=='create'){
				this.create(selectedIndexs, column_data);
			}else if(buttonname=='email'){
				this.email(selectedIndexs, column_data);
			}else if(buttonname=='erp'){
				this.erp(selectedIndexs, column_data);
			}else if(buttonname=='upload'){
				this.upload();
			}
		},
		upload() {
			this.upload_dialogue = true
		},
		cancelUpload() {
			this.upload_dialogue = false
		},
		create(selectedIndexs, column_data){
			var sentInvoices = [];
			for(var i = 0;i<selectedIndexs.length;i++){
				api.postData(
					{
						type:"insert",
						data:{
							pageid:this.pageid,
							limit:this.limit,
							data:[
								column_data[selectedIndexs[i]][0],
							],
						}
					}
				)
				if(column_data[selectedIndexs[i]][10]=='Created'){
					column_data[selectedIndexs[i]][10] = 'SentToQB';
					sentInvoices.push(column_data[selectedIndexs[i]][1]);
				}
			}
			alert("Sent Invoices:\n"+sentInvoices);
		},
		email(selectedIndexs, column_data){
			let emailedInvoices = [];
			let errorInvoices = [];
			let promises = [];

			for(let i = 0;i<selectedIndexs.length;i++){
				promises.push(api.postData(
					{
						type:"button",
						data:{
							pageid:this.pageid,
							limit:this.limit,
							data:[
								column_data[selectedIndexs[i]][1],
							],
						}
					}
				).then((res)=>{
					if(res.data.status == 'ok'){

						column_data[selectedIndexs[i]][10] = 'Sent';
						emailedInvoices.push(column_data[selectedIndexs[i]][1]);
					}else{
						errorInvoices.push(res.data.status +", Invoice ID:"+ column_data[selectedIndexs[i]][1]);
					}
				}));
			}

			Promise.all(promises).then((results) => {
				var message = '';
				if(emailedInvoices.length>0){
					message+="Emailed Invoices:";
					for(let i = 0;i<emailedInvoices.length;i++){
						message+='\n'+emailedInvoices[i];
					}
				}
				if(errorInvoices.length>0){
					if(message!=''){
						message+='\n\n';
					}
					message+="Errors:"
					for(let i = 0;i<errorInvoices.length;i++){
						message+='\n'+errorInvoices[i];
					}

				}
				alert(message);
			});
		},
		erp(selectedIndexs, column_data){
			console.log("ERP")
			for(var i = 0;i<selectedIndexs.length;i++){
				console.log(selectedIndexs[i])
				console.log(column_data[selectedIndexs[i]][0])
				api.postData({
					type:"erpnext",
					data:{
						pageid:this.pageid,
						data:[
							column_data[selectedIndexs[i]][0],
						],
					}
				})
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Invoice_Status.vue